import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Typography } from "@mui/material";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import LinkIcon from "@mui/icons-material/Link";
import { useEffect, useState } from "react";
export var handleOnCopy = function (value, label) {
    if (value && typeof value === "string") {
        navigator.clipboard.writeText(value);
    }
};
var CopyLinkButton = function (_a) {
    var label = _a.label, value = _a.value, children = _a.children, _b = _a.IconProps, IconProps = _b === void 0 ? {} : _b, _c = _a.copiedText, copiedText = _c === void 0 ? "Link copied!" : _c, props = __rest(_a, ["label", "value", "children", "IconProps", "copiedText"]);
    var _d = useState(false), copied = _d[0], setCopied = _d[1];
    useEffect(function () {
        if (copied) {
            setTimeout(function () {
                setCopied(false);
            }, 1000);
        }
    }, [copied]);
    return (_jsx(Button, __assign({ "data-testid": "".concat(label, "-Copy-Button"), className: "Pangea-Copy-Button", onClick: function () {
            handleOnCopy(value, label);
            setCopied(true);
        }, startIcon: _jsx(LinkIcon, { fontSize: "small" }), endIcon: copied ? (_jsx(CheckCircleOutlineOutlinedIcon, __assign({ fontSize: "small" }, IconProps))) : (_jsx(ContentCopyOutlinedIcon, __assign({ fontSize: "small" }, IconProps))) }, props, (copied && {
        color: "success",
    }), { children: _jsx(Typography, { variant: "body2", sx: {
                width: "calc(100% - 40px)",
                overflow: "hidden",
                textOverflow: "ellipsis",
            }, children: copied ? copiedText : children }) })));
};
export default CopyLinkButton;
